import { OptionsField } from '@publishing-engine/domain/types/article';
import { useQuery } from '@tanstack/react-query';
import { getFocusIsuue } from 'src/api/queries';

export default function useFocusIssueConfig(ctxId: string, value?: string) {
  const { data: focusIssue } = useQuery({
    queryKey: ['focus-issue', { id: ctxId }],
    queryFn: () => getFocusIsuue(ctxId),
    retry: 0
  });

  const { validationOptions, labelOptions } = (focusIssue?.data ?? []).reduce(
    (acc, item) => {
      acc.labelOptions[item.id] = {
        main: item.name
      };

      if (item.status === 'open') {
        acc.validationOptions.push(item.id);
      }

      return acc;
    },
    {
      validationOptions: [''],
      labelOptions: {}
    } as {
      labelOptions: OptionsField;
      validationOptions: string[];
    }
  );

  const selectedFocusIssue = focusIssue?.data?.find(item => item.id === value);

  return {
    validationOptions,
    labelOptions,
    guidelineLink: focusIssue?.guidelineLink,
    selectedFocusIssue
  };
}
